"use client";
import useScrollPosition from "@/hooks/use-scroll-position";
import { ArrowRight, ChevronDown } from "lucide-react";
import Link from "next/link";
import { Parallax } from "react-scroll-parallax";
import { useIsClient, useMediaQuery } from "usehooks-ts";

export default function LandingHeroInteractive() {
	const isClient = useIsClient();
	const isDesktop = useMediaQuery("(min-width: 768px)");

	return (
		<section className="relative h-dvh md:h-auto md:min-h-[50dvh] overflow-hidden bg-black">
			<Parallax className="absolute inset-0" translateY={[-50, 50]}>
				<div
					className="absolute inset-0 bg-cover bg-center transition-transform duration-100 ease-out"
					style={{
						backgroundImage: `url('/assets/hero-bg.jpg')`,
						scale: 1.4,
					}}
				/>
			</Parallax>

			<div className="relative inset-0 z-10 grid h-full md:min-h-[50dvh] w-full place-items-center bg-black/50 text-center backdrop-blur-sm transition-all duration-500 hover:bg-black/70 hover:backdrop-blur-[1px]">
				<div className="max-w-xl p-2">
					<h1 className="mb-6 text-4xl font-bold text-primary-foreground md:text-6xl">
						Unutulmaz Bir Deneyim Sunun
					</h1>
					<p className="mb-8 font-josefin text-xl text-primary-foreground/90">
						Fobby ile anılarınızı yapay zeka sihriyle dönüştürün! Fotoğraf
						çektirmek hiç bu kadar eğlenceli olmamıştı.
					</p>
					<Link
						href={"/sign-in"}
						className="inline-flex items-center rounded-lg bg-background px-6 py-3 font-semibold text-foreground transition-colors hover:bg-accent"
					>
						Hemen Başla
						<ArrowRight className="ml-2 h-5 w-5" />
					</Link>
				</div>
			</div>
			{isDesktop === false && isClient && <ScrollDownIndicator />}
		</section>
	);
}

function ScrollDownIndicator() {
	const scrollY = useScrollPosition();

	if (scrollY > 20) {
		return null;
	}

	return (
		<div className="absolute bottom-4 left-0 z-20 flex h-4 w-full justify-center text-white">
			<ChevronDown className="animate-bounce" />
		</div>
	);
}
